import { Component } from '@angular/core';

@Component({
    selector: 'app-confetti',
    templateUrl: './confetti.component.html',
    styleUrl: './confetti.component.scss'
})
export class ConfettiComponent {

}
